const ArrowRightNew = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.62963 11.0969H18.9262V12.8852H3.62963V11.0969Z'
        fill='#E9E6E6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.112 11.8722L13.3823 7.26449L14.6803 6L19.41 10.6077C20.1992 11.3766 20.1926 12.6189 19.4145 13.3878L19.41 13.3923L14.6803 18L13.3823 16.7355L18.1088 12.1309C18.1859 12.0533 18.179 11.9375 18.112 11.8722Z'
        fill='#E9E6E6'
      />
      <path
        d='M4.88889 12.9304V11.1304H3.62963L3 12.9304H4.88889Z'
        fill='#E9E6E6'
      />
    </svg>
  );
};

export default ArrowRightNew;
